<template>
  <div class="customer">
    <div class="title">
      <span>客户订单统计</span>
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <!-- <mu-form-item prop="userId" label="客户" label-position="left">
        <mu-select v-model="form.customerId">
          <mu-option v-for="(user, index) in customerList" :key="index" :label="user.realName" :value="user.id"></mu-option>
        </mu-select>
      </mu-form-item> -->

      <mu-form-item prop="userId" label="客户" label-position="left">
        <mu-auto-complete
          :data="customerList"
          :max-search-results="5"
          v-model="form.customerStr"
          open-on-focus
          :filter="customerFilter"
          @select="customerSelect"
          class="customer"
        >
          <template slot-scope="scope">
            <mu-list-item-content
              v-html="scope.highlight"
            ></mu-list-item-content>
          </template>
        </mu-auto-complete>
      </mu-form-item>

      <mu-form-item prop="search" label="开始时间" label-position="left">
        <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
      </mu-form-item>
      <mu-form-item prop="search" label="结束时间" label-position="left">
        <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
      </mu-form-item>
      <mu-form-item class="search-btn">
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </mu-form-item>
    </mu-form>
    <div class="analysis">
      <mu-button fab color="indigo" large>
        {{ sum }}
      </mu-button>
    </div>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>{{ scope.row.name }}</td>
          <td>{{ scope.row.sum }}</td>
        </template>
      </mu-data-table>
    </mu-paper>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
export default {
  data() {
    return {
      loading: false,
      form: {
        customerStr: '',
        customerId: 0,
        startTime: moment().startOf('month').toDate(),
        endTime: moment().endOf('month').toDate()
      },
      columns: [
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '总价',
          name: 'user',
          align: 'center'
        }
      ],
      list: [],
      customerList: [],
      sum: 0
    }
  },
  methods: {
    getAll() {
      this.loading = true
      backend(api.order.customerReporter, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data
          let sum = numeral(0)
          result.data.forEach((item) => {
            sum.add(item.sum)
          })
          this.sum = sum.value().toFixed(2)
        }
      })
    },
    getAllCustomer() {
      backend(api.user.getAll, { getAll: true, isCustomer: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.customerList = result.data.rows
          }
        }
      )
    },
    customerFilter(text, data, maxSearchResults) {
      return data
        .filter(
          (x) => x.realName.indexOf(text) > -1 || x.company.indexOf(text) > -1
        )
        .map((item) => {
          const value = item.company + ' - ' + item.realName
          return {
            value,
            item,
            highlight: `<span>${value.replace(
              text,
              '<span class="mu-secondary-text-color">' + text + '</span>'
            )}</span>`
          }
        })
    },
    customerSelect(value, item) {
      if (item) {
        this.form.customerId = item.id
      } else {
        this.form.customerId = null
      }
    }
  },
  mounted() {
    this.getAll()
    this.getAllCustomer()
  }
}
</script>

<style lang="less" scoped>
.customer {
  position: relative;
  .form {
    position: relative;
  }
  .analysis {
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reporter/customer.vue